export let LatestMessageAccess;
(function (LatestMessageAccess) {
  LatestMessageAccess["ACCESS"] = "ACCESS";
  LatestMessageAccess["NO_ACCESS"] = "NO_ACCESS";
})(LatestMessageAccess || (LatestMessageAccess = {}));